/* eslint-disable @typescript-eslint/no-explicit-any */
import 'reflect-metadata';
import { fromEvent } from 'rxjs';

export const proxyOutputs = (instance: any, el: any, events: string[]): void => {
  events.forEach((eventName) => (instance[eventName] = fromEvent(el, eventName)));
};

export const proxyInputs = (Cmp: any, inputs: string[]): void => {
  const Prototype = Cmp.prototype;
  const formBooleanAttributes = [
    // Core attributes
    'disabled',
    'required',
    'invalid',
    'readonly',
    'readOnly',
    'multiple',

    // Select & option attributes
    'selected',
    'clearable',
    'quick',
    'clampMenuWidth',

    // Checkbox attributes
    'checked',
    'indeterminate',

    // Text field specific
    'truncate',
    'autofocus',
  ];

  inputs.forEach((inputName) => {
    Object.defineProperty(Prototype, inputName, {
      get() {
        return this.el[inputName];
      },
      set(val: any) {
        this._ngZone?.runOutsideAngular(() => {
          if (formBooleanAttributes.includes(inputName)) {
            if (val === true || val === '') {
              this.el.setAttribute(inputName, '');
            } else {
              this.el.removeAttribute(inputName);
            }
          } else {
            this.el[inputName] = val != null ? val.toString() : val;
          }
        });
      },
      configurable: true,
    });
  });
};

export const proxyMethods = (Cmp: any, methods: string[]): void => {
  const Prototype = Cmp.prototype;
  methods.forEach((methodName) => {
    Prototype[methodName] = function (...args: any[]) {
      return this._ngZone.runOutsideAngular(() => this.el[methodName].apply(this.el, ...args));
    };
  });
};

export function ProxyWebComponent(opts?: { methods?: string[] }) {
  const decorator = function (target: any) {
    const ɵcmp = (target as any).ɵcmp;

    if (!ɵcmp) {
      throw new Error('Component metadata (ɵcmp) not found. Ensure the class is decorated with @Component.');
    }

    const inputs = Object.keys(ɵcmp.inputs);
    const outputs = Object.keys(ɵcmp.outputs);

    if (inputs) {
      proxyInputs(target, inputs);
    }
    if (opts?.methods) {
      proxyMethods(target, opts.methods);
    }
    if (outputs) {
      (target as any)._outputs = outputs;
    }

    return target;
  };

  return decorator;
}
